import * as Sentry from '@sentry/react'
import { beforeBreadcrumb, beforeSend } from './sentry-scrub'

let started = false

/** Start browser error reporting once, if the server handed us a DSN. No-op otherwise. */
export function initClientSentry(dsn: string | null, environment: string) {
  if (started || !dsn) return
  Sentry.init({
    dsn,
    environment,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
    // Errors only. No tracing, session replay or request bodies ever leave the browser.
    tracesSampleRate: 0,
    beforeSend,
    beforeBreadcrumb,
  })
  started = true
}

export function reportClientError(error: unknown) {
  if (started) Sentry.captureException(error)
}
